import React from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { router } from './App';
import { AuthProvider } from './auth';
import { BasketProvider } from './basket';
import { PrefsProvider } from './prefs';
import { ToastProvider } from './components/Toast';
import { loadLocale, setLocale } from './i18n';
import { initialLocale, LocaleProvider } from './i18n/LocaleProvider';
import './styles.css';

// respect the OS preference, remember an explicit choice
let stored: string | null = null;
try {
  stored = localStorage.getItem('studio-theme');
} catch {
  stored = null;
}
const dark = stored ? stored === 'dark' : window.matchMedia('(prefers-color-scheme: dark)').matches;
document.documentElement.classList.toggle('dark', dark);

const render = () =>
  createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <ToastProvider>
        <AuthProvider>
          <PrefsProvider>
            <BasketProvider>
              <LocaleProvider>
                <RouterProvider router={router} />
              </LocaleProvider>
            </BasketProvider>
          </PrefsProvider>
        </AuthProvider>
      </ToastProvider>
    </React.StrictMode>,
  );

// the first paint in the language this browser last used (German loads its words first)
const locale = initialLocale();
loadLocale(locale)
  .then(() => setLocale(locale))
  .catch(() => setLocale('en'))
  .finally(render);
